import ConfirmDialog from "@/components/confirm-dialog";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";
import { Module } from "@/constants";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";
import { useSettlementId } from "@/modules/projects/hooks/useSettlementId";
import { reopenProjectSettlement } from "@/modules/projectSettlements/service/projectSettlements";
import { useQueryClient } from "@tanstack/react-query";
import { UnlockIcon } from "lucide-react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import Spinner from "@/components/Spinner";

export const SettlementReopenButton = () => {
  const { t } = useTranslation();
  const settlementId = useSettlementId();

  const { toast } = useToast();
  const queryClient = useQueryClient();

  const mutation = useMutationWithErrorHandling({
    errorTitle: t("projectSettlements.errors.reopen"),
    mutationFn: reopenProjectSettlement,
    onSuccess: () => {
      toast({
        title: t("projectSettlements.success.reopen"),
      });
      queryClient.invalidateQueries({
        queryKey: [Module.ProjectSettlements, settlementId],
      });
    },
  });

  const onConfirm = useCallback(() => {
    mutation.mutateAsync(settlementId);
  }, [mutation, settlementId]);

  return (
    <ConfirmDialog
      title={t("projectSettlements.reopen.title")}
      content={t("projectSettlements.reopen.content")}
      onConfirm={onConfirm}
    >
      <Button variant="ghost" disabled={mutation.isPending}>
        {mutation.isPending ? (
          <Spinner />
        ) : (
          <UnlockIcon className="w-4 h-4 mr-1" />
        )}
        {t("projectSettlements.reopen.trigger")}
      </Button>
    </ConfirmDialog>
  );
};
